<template>
  <div class="news">
    <router-view></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.news >>> .news-top {
  padding-top: 71px;
}
.news >>> .marginT {
  margin-top: 100px;
}
.news >>> .marginB {
  margin-bottom: 8rem;
}
</style>
